module.exports = __webpack_public_path__ + "static/media/16UNODC31.829711d1.jpg";